import { render, staticRenderFns } from "./Benvenuto.vue?vue&type=template&id=0faa32b8&scoped=true&"
import script from "./Benvenuto.vue?vue&type=script&lang=js&"
export * from "./Benvenuto.vue?vue&type=script&lang=js&"
import style0 from "./Benvenuto.vue?vue&type=style&index=0&id=0faa32b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa32b8",
  null
  
)

export default component.exports